// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"_16lpJ","right":"_2bMrB","left":"_1GIa8"};